import React from 'react';
const CART_URL = 'https://www.tusoluciondigital.shop/cart/43130152714306:1';
export function FinalCTA() {
  return <section className="bg-purple-900 text-white py-16 md:py-20 px-4" data-id="element-103">
      <div className="max-w-4xl mx-auto text-center" data-id="element-104">
        <h2 className="text-4xl md:text-5xl font-black mb-8" data-id="element-105">💖 Déjalo ir</h2>

        <div className="space-y-4 text-xl md:text-2xl mb-10" data-id="element-106">
          <p data-id="element-107">No necesitás seguir sufriendo.</p>
          <p data-id="element-108">No necesitás esperar que él cambie.</p>
          <p className="font-black text-yellow-300 text-2xl md:text-3xl mt-6" data-id="element-109">
            SOLO TENES QUE APRENDER A PRIORIZARTE. A TOMAR DESICIONES Y A NO
            ROMANTIZAR TODOS LOS VINCULOS. ELEGITE.
          </p>
        </div>

        <div className="space-y-6" data-id="element-110">
          <a href={CART_URL} className="inline-block bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-xl md:text-2xl px-10 md:px-16 py-5 md:py-6 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 uppercase" data-id="element-111">
            👉 Sí
          </a>

          <div data-id="element-112">
            <a href={CART_URL} className="inline-block bg-white hover:bg-gray-100 text-purple-900 font-black text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 uppercase" data-id="element-113">
              👉 EMPEZAR HOY POR $19.999
            </a>
          </div>
        </div>
      </div>
    </section>;
}